import axios from "axios"
import baseURL from "../configs/api"

export const post_Relation = (data: any, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}relation?userId=${userId}`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const put_Relation = (data: any, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}relation?userId=${userId}`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const getRelationByCustomer = (customerId: string, tenantId: string) => {
    return getFetch(`relation/GetRelationsOfCustomer/${customerId}`, tenantId);
}

export const getRelationships = (tenantId: string) => {
    return getFetch(`relationship`, tenantId);
}

export const getRelationMapping = (tenantId: string) => {
    return getFetch(`relationMapping`, tenantId);
}

export const delete_Relation = (id: number, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}relation`,
        method: "DELETE",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: { id: id, userId: userId }
    }).then(response => response.data);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: params
    }).then(response => response.data);
}